<template>
  <div
    v-if="suggestions && suggestions.length"
    class="suggestions-container mb-3"
  >
    <div class="font-weight-medium mb-2">Handlungsempfehlung:</div>
    <div class="suggestions-list">
      <v-alert
        v-for="suggestion in suggestions"
        :key="suggestion.text"
        :type="getSuggestionAlertType(suggestion.type)"
        dense
        text
        class="mb-2 suggestion-alert"
        :class="{ 'clickable-suggestion': suggestion.action }"
        :icon="suggestion.icon"
        @click="suggestion.action && handleSuggestionClick(suggestion)"
      >
        <div class="d-flex align-center">
          <span class="flex-grow-1">{{ suggestion.text }}</span>
          <v-btn
            v-if="suggestion.action"
            icon
            x-small
            color="primary"
            class="ml-2"
          >
            <v-icon small>mdi-arrow-right</v-icon>
          </v-btn>
        </div>
      </v-alert>
    </div>
  </div>
</template>

<script>
export default {
  name: "SuggestionsAlert",
  props: {
    suggestions: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getSuggestionAlertType(type) {
      const typeMap = {
        success: "success",
        warning: "warning",
        info: "info",
      };
      return typeMap[type] || "info";
    },
    handleSuggestionClick(suggestion) {
      this.$emit("suggestion-action", suggestion);
    },
  },
};
</script>

<style scoped>
.suggestions-container {
  background-color: #fafafa;
  border-radius: 4px;
  padding: 8px;
}

.clickable-suggestion {
  cursor: pointer;
  transition: transform 0.2s ease;
}

.clickable-suggestion:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
</style>
